import React, { Fragment } from "react";

import styles from "./Timeline.style";
import Moment from 'moment';
import 'moment/locale/fr'

import { Typography } from "antd";
import dayjs from "dayjs";

const {Text}=Typography

function _isEmpty(value){
  return value==null || value==""
}

const EventTime = ({ time: { content, style: timeStyle } = {}, style,date }) => {
  return (
    <div style={{...styles.timeContainer, ...style}}>
      <Text style={{...styles.time, ...timeStyle}}>{dayjs(date).format('dddd DD MMMM')}</Text>
    </div>
  );
};


/*
Event component, is the component in which you can render whatever the event is about,
e.g. Title, description, or even render a custom template by sending a render-prop with whatsoever
content you need.
*/
const Event = ({ children, style }) => {
  return <div style={{...styles.eventContainer, ...style}}>{children}</div>;
};

const EventIcon = ({ icon: OriginalIcon = {}, iconStyle, lineStyle }) => {
  // Determines whether we are trying to render a custom icon component, or use the default
  const iconIsComponent = typeof OriginalIcon === "function";
  let iconToBeRendered = iconIsComponent ? (
    <OriginalIcon styles={styles.icon} />
  ) : (
    <div
      style={{height:15,width:15,borderRadius:50,backgroundColor:"#6F98FA"}}
    />
  );

  return (
    <div style={{...styles.iconContainer, ...iconStyle}}>
      {iconToBeRendered}
      <div style={{...styles.verticalLine, ...lineStyle}} />
    </div>
  );
};

/*
Row component, is the component that combines all the sub-components (EventIcon, Event, EventTime) and
gets each 'event' as an argument of type object
*/
const Row = ({
  event = {},
  eventStyle,
  timeContainerStyle,
  iconContainerStyle,
  lineStyle,
  contentContainerStyle
}) => {
  const {
    title: OriginalTitle = {},
    description: OriginalDescription = {},
    date,
    items,
    time,
  } = event;


  // Determines whether the title is just a text and its style, or a render-prop function, and acts accrodingly
  const titleIsComponent = OriginalTitle && typeof OriginalTitle === "function";
  const title = titleIsComponent ? (
    <OriginalTitle styles={styles.title} />
  ) : (
    typeof OriginalTitle === "object" &&
    !_isEmpty(OriginalTitle) && (
      <Text style={{...styles.title, ...OriginalTitle.style}}>
        {OriginalTitle.content}
      </Text>
    )
  );

  // Determines whether the description is just a text and its style, or a render-prop function, and acts accrodingly
  const descriptionIsComponent =
    OriginalDescription && typeof OriginalDescription === "function";
  const description = descriptionIsComponent ? (
    <OriginalDescription styles={styles.description} />
  ) : (
    typeof OriginalDescription === "object" &&
    !_isEmpty(OriginalDescription) && (
      <Text style={{...styles.description, ...OriginalDescription.style}}>
        {OriginalDescription.content}
      </Text>
    )
  );

  return (
    <div style={{...styles.row, ...eventStyle}}>
      <EventTime date={date} time={time} style={timeContainerStyle} />
      <EventIcon
        iconStyle={iconContainerStyle}
        lineStyle={lineStyle}
      />
      <Event style={contentContainerStyle}>

      {items.map((h,index)=>{
        return(
          <Fragment key={index}>

            <div  style={{display:'flex',width:"100%",marginTop:index>0?10:0,flexDirection:"row",justifyContent:"space-between",alignItems:"center"}}>
              <Text style={{fontWeight:"700",fontSize:15,color:"#000",maxWidth:"80%"}}>{h.name}</Text>
              <Text style={{fontWeight:"500",fontSize:12,color:"#000"}}>
                {dayjs()
                    .hour(h.heure)
                    .minute(h.minute)
                    .locale(h.context?.langValue || "fr")
                    .format('LT')}
              </Text>
            </div>

            {index<items.length-1&&(
                <div style={{display:'flex',alignSelf:"center",width:"60%",borderTop:"0.5px solid #ddd",marginTop:20}}/>
            )}
          </Fragment>
        )
      })}

      </Event>
    </div>
  );
};

/*


*/

export default function Timeline({
  data = [], // The actual event's array, array of objects, each object represents a single event
  eventStyle = {}, // Each event's whole row's style
  timeContainerStyle = {}, // The style object of the container that holds the time
  iconContainerStyle = {}, // The style object of the container that holds the icon
  lineStyle = {}, // The vertical line's style object
  contentContainerStyle = {}, // The style object of the container that holds the content i.e. title and description
  onEndReachedThreshold,
  onEndReached,
  TimelineFooter,
  TimelineHeader,
  ...rest
}){
  const events = (
    <div>
      <TimelineHeader/>
        <div style={{padding:"10px 0",paddingBottom:50}}>
          {data.map((item,index)=>{
            return(
              <Row
                key={index}
                event={item}
                eventStyle={eventStyle}
                timeContainerStyle={timeContainerStyle}
                iconContainerStyle={iconContainerStyle}
                lineStyle={lineStyle}
                contentContainerStyle={contentContainerStyle}
              />
            )
          })}
        </div>
    </div>
  );

  return <div style={styles.container}>{events}</div>;
};

